import React from 'react';
import env from 'env';
import I18n from '../../../config/i18n';
import QWLogo from '../../icons/qube-wire-logo.svg';

export default class NoAccessHeader extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="app__header h6 noselect">
        <div className="ui-toolbar" style={{ paddingTop: '8px' }}>
          <div className="ui-toolbar__group">
            <QWLogo className="svg-icon svg-logo-3x" />
          </div>
          <div className="ui-toolbar__group mxn3" style={{ margin: 10 }}>
            <a
              href={`${env.qwPartnersBaseUrl}/v1/web/auth/logout`}
              style={{ color: 'white' }}
            >
              <div className="sm-col landingPage_button">
                {I18n.t('signOut')}
              </div>
            </a>
          </div>
        </div>
      </div>
    );
  }
}

NoAccessHeader.propTypes = {};
